import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 11.5V12.5C2 12.6326 2.05268 12.7598 2.14645 12.8535C2.24021 12.9473 2.36739 13 2.5 13H18.67L14.22 17.44C14.1734 17.4856 14.1364 17.5401 14.1112 17.6002C14.0859 17.6603 14.0729 17.7248 14.0729 17.79C14.0729 17.8552 14.0859 17.9197 14.1112 17.9798C14.1364 18.0399 14.1734 18.0944 14.22 18.14L14.93 18.85C14.9765 18.8968 15.0318 18.934 15.0927 18.9594C15.1536 18.9848 15.219 18.9979 15.285 18.9979C15.351 18.9979 15.4164 18.9848 15.4773 18.9594C15.5382 18.934 15.5935 18.8968 15.64 18.85L21.78 12.72C21.9189 12.5783 21.9977 12.3884 22 12.19V11.81C21.9998 11.6111 21.9207 11.4205 21.78 11.28L15.64 5.14997C15.5935 5.10311 15.5382 5.06591 15.4773 5.04053C15.4164 5.01514 15.351 5.00208 15.285 5.00208C15.219 5.00208 15.1536 5.01514 15.0927 5.04053C15.0318 5.06591 14.9765 5.10311 14.93 5.14997L14.22 5.84997C14.1731 5.89646 14.1359 5.95176 14.1106 6.01269C14.0852 6.07362 14.0721 6.13897 14.0721 6.20497C14.0721 6.27098 14.0852 6.33633 14.1106 6.39726C14.1359 6.45819 14.1731 6.51349 14.22 6.55997L18.67 11H2.5C2.36739 11 2.24021 11.0527 2.14645 11.1464C2.05268 11.2402 2 11.3674 2 11.5Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgForwardOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgForwardOutline;
